<ng-container>
  <div class="card p-2 shadow">
    @if (showSpinner) {
      <ng-container>
        <div class="p-2 d-flex align-items-center">
          Getting Data
          <div class="spinner-grow float-end ms-2" role="status"></div>
        </div>
      </ng-container>
    } @else {
      <ng-container>
        <div class="d-flex gap-3">
          @if (userDetailData?.profile_image) {
            <div class="text-center">
              <img
                src="{{ userDetailData?.profile_image }}"
                alt="User Profile Image"
                style="height: 175px"
                class="rounded"
              />
            </div>
          }

          <div class="d-flex column-gap-5 flex-wrap p-2">
            <div class="d-flex gap-2">
              <dl>
                <dt>User</dt>
                <dd class="fw-bold">
                  @if (userFullName) {
                    {{ userFullName }}
                  } @else {
                    [PENDING SIGN-IN]
                  }
                </dd>
              </dl>
              @if (userDetailData?.access_status == 1) {
                <span>
                  <i class="fa-solid fa-circle text-success fs-3"></i>
                </span>
              } @else {
                <span>
                  <i class="fa-regular fa-circle text-body fs-3"></i>
                </span>
              }
            </div>
            @if (userDetailData?.sub_contractor?.id) {
              <div class="mb-4">
                <dt>Subcontractor</dt>
                <dd>
                  <span class="text-orange fw-medium">
                    {{ userDetailData?.sub_contractor?.company_name }}
                  </span>
                </dd>
              </div>
            }

            @if (
              userDetailData?.user_add_info?.last_activity &&
              userDetailData?.user_add_info?.last_activity_time
            ) {
              <div>
                <dl>
                  <dt>Last Update</dt>
                  <dd>
                    {{
                      userDetailData?.user_add_info?.last_activity | titlecase
                    }}
                    |
                    {{
                      userDetailData?.user_add_info?.last_activity_time
                        | customDate: "d MMM y HH:mm"
                    }}
                  </dd>
                </dl>
              </div>
            }

            <dl>
              <div class="row align-items-center">
                <div>
                  <dt>Email</dt>
                  <dd>
                    <a
                      href="mailto:{{ userDetailData?.email }}"
                      class="text-decoration-none"
                      >{{ userDetailData?.email }}</a
                    >
                  </dd>
                </div>
              </div>
            </dl>

            @if (userDetailData?.user_add_info?.contact_number) {
              <dl>
                <dt>Preferred Contact Number</dt>
                <dd>
                  <a
                    href="tel:+{{
                      userDetailData?.user_add_info?.contact_number
                    }}"
                    >{{ userDetailData?.user_add_info?.contact_number }}</a
                  >
                </dd>
              </dl>
            }
            @if (userDetailData?.mobile_number) {
              <dl>
                <dt>User Mobile</dt>
                <dd>
                  <a href="tel:+{{ userDetailData?.mobile_number }}">{{
                    userDetailData?.mobile_number
                  }}</a>
                </dd>
              </dl>
            }

            <dl>
              <dt>Permissions</dt>
              <dd>
                @for (
                  grp of userDetailData?.user_group;
                  track grp;
                  let l = $last
                ) {
                  <span
                    >{{ grp?.name }}
                    @if (!l) {
                      <span>, </span>
                    }
                  </span>
                }
              </dd>
            </dl>
            @if (userTags?.length) {
              <dl>
                <dt>Tags</dt>
                <dd>
                  @for (tag of userTags; track tag; let l = $last) {
                    <span
                      >{{ tag }}
                      @if (!l) {
                        <span>, </span>
                      }
                    </span>
                  }
                </dd>
              </dl>
            }
          </div>
        </div>
        @if (userDetailData?.credentials?.length) {
          <hr />
          <div class="fw-bold">Credentials</div>
          <div class="row row-cols-auto">
            @for (cred of userDetailData?.credentials; track cred) {
              <div class="col small">
                <div
                  [ngClass]="
                    cred?.expiry_code === 2
                      ? 'card p-2 bg-danger-subtle h-100 opacity'
                      : 'card p-2 bg-secondary-subtle h-100'
                  "
                  [class.expired-licence]="cred?.expiry_code === 2"
                >
                  @if (cred?.expiry_code === 2) {
                    <div class="text-center fw-bold">EXPIRED</div>
                  }
                  <div class="p-1">
                    <div
                      class="d-flex gap-3 justify-content-between align-items-center"
                    >
                      @if (cred?.id_type) {
                        <dl class="mb-1">
                          <dd class="fw-semibold">{{ cred?.id_type }}</dd>
                        </dl>
                      }
                      @if (cred?.issuer_state) {
                        <dl class="mb-1">
                          <dd class="fs-4 fw-semibold">
                            {{ cred?.issuer_state }}
                          </dd>
                        </dl>
                      }
                    </div>
                    <div class="d-flex flex-wrap gap-3">
                      <dl class="mb-1">
                        <dt>Licence No.</dt>
                        <dd>{{ cred?.id_number }}</dd>
                      </dl>
                      @if (cred?.licence_class) {
                        <dl class="mb-1">
                          <dt>Class</dt>
                          <dd>{{ cred?.licence_class }}</dd>
                        </dl>
                      }
                      <dl class="mb-1">
                        <dt>Valid Till</dt>
                        @if (cred?.valid_till) {
                          <dd>{{ cred?.valid_till | date: "YYY-MM-d" }}</dd>
                        } @else {
                          <dd>No Expiry</dd>
                        }
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </ng-container>
    }
  </div>
</ng-container>
